<template>
  <v-dialog v-model="visibilidade" persistent width="300">
    <v-card :color="cor" dark>
      <v-card-text>
        <v-row class="justify-center">
          <div class="mt-2">
            {{ texto }}
          </div>
          <v-progress-linear indeterminate :color="corTexto" class="mb-0" />
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AppLoading',

  props: {
    visibilidade: {
      type: Boolean,
      default: false,
    },
    cor: {
      type: String,
      default: 'primary',
    },
    corTexto: {
      type: String,
      default: 'white',
    },
    texto: {
      type: String,
      default: 'Aguarde. Carregando...',
    },
  },
};
</script>
